import { BACKEND_URL_PREFIX, itemsOnPage } from '../utils/const';
import {
  GET_LESSON_PLAN_REQUEST_STARTED,
  GET_LESSON_PLAN_REQUEST_COMPLETED,
  GET_LESSON_PLAN_REQUEST_FAILED,
  SET_LESSON_PLAN_COUNT,
  GET_LESSON_PLAN_CURRICULM,
  GET_LESSON_PLAN_TERM_REQUEST_COMPLETED
} from './types';
import { buildDefaultHeaders } from './helper';



export const getLessonPlan = (params) =>
  async (dispatch, getState) => {
    const { year, faculty, curriculum, disciplineRPD, discipline, kurs, semester, numberPage } = params;

    const queryParams = {
      limit: itemsOnPage,
      offset: (numberPage || 0) * itemsOnPage
    };

    // Добавляем только ненулевые опциональные фильтры
    if (faculty && faculty !== 0 && faculty !== '0') {
      queryParams.idfaculty = faculty;
    }
    if (curriculum && curriculum !== 0 && curriculum !== '0') {
      queryParams.idcurriculum = curriculum;
    }
    if (disciplineRPD && disciplineRPD !== 0 && disciplineRPD !== '0') {
      queryParams.cid = disciplineRPD;
    }
    if (discipline && discipline !== 0 && discipline !== '0') {
      queryParams.idmetacourse = discipline;
    }
    if (kurs && kurs !== 0 && kurs !== '0') {
      queryParams.eyid = kurs;
    }
    if (semester && semester !== 0 && semester !== '0') {
      queryParams.tlid = semester;
    }

    const urlParams = new URLSearchParams(queryParams).toString();
    dispatch({ type: GET_LESSON_PLAN_REQUEST_STARTED });
    const url = `${BACKEND_URL_PREFIX}/lessonplans/subjects/${year}?${urlParams}`;
    const response = await fetch(`${url}`, buildDefaultHeaders(getState));
    if (response.ok) {
      const result = (await response.json());
      const payload = Math.ceil(result.count / itemsOnPage);
      dispatch({ type: GET_LESSON_PLAN_REQUEST_COMPLETED, data: result });
      dispatch({ type: SET_LESSON_PLAN_COUNT, data: payload });
    } else {
      dispatch({ type: GET_LESSON_PLAN_REQUEST_FAILED });
    }
  };
export const getLessonPlanTerm = (params) =>
  async (dispatch, getState) => {
    const { year, faculty, curriculum, disciplineRPD, discipline, kurs, semester, numberPage } = params
    const url = `${BACKEND_URL_PREFIX}/year/term/${year}/${faculty}/${curriculum}/${kurs}`;
    const response = await fetch(`${url}`, buildDefaultHeaders(getState));
    if (response.ok) {
      const result = (await response.json());
      dispatch({ type: GET_LESSON_PLAN_TERM_REQUEST_COMPLETED, data: result });
    } else {
    }
  };

export const getLessonPlanByYearAndFuk = (year, faculty) =>
  async (dispatch, getState) => {

    const url = `${BACKEND_URL_PREFIX}/lesson_plans/curriculum/${year}/${faculty}`;
    const response = await fetch(`${url}`, buildDefaultHeaders(getState));
    if (response.ok) {
      const result = (await response.json());

      dispatch({ type: GET_LESSON_PLAN_CURRICULM, data: result });
    } else {
    }
  };
